import { useCallback, useState } from 'react'

export interface StickerType {
  id: string;
  url: string;
  x: number;
  y: number;
  width: number;
  height: number;
  rotation?: number;
}

const useStickers = () => {
  const [stickers, setStickers] = useState<StickerType[]>([]);
  const [selectedStickerId, setSelectedStickerId] = useState<string | null>(null);

  const addSticker = useCallback((src: string) => {
    const newSticker: StickerType = {
      id: `sticker-${Date.now()}`,
      url: src,
      x: 140,
      y: 200,
      width: 100,
      height: 100,
      rotation: 0,
    };
    setStickers((prev) => [...prev, newSticker]);
    setSelectedStickerId(newSticker.id);
  }, [])

  const updateSticker = useCallback((id: string, updates: Partial<StickerType>) => {
    setStickers((prev) =>
      prev.map((sticker) =>
        sticker.id === id ? { ...sticker, ...updates } : sticker
      )
    );
  }, [])

  const selectSticker = useCallback((id: string) => {
    setSelectedStickerId(id);
  }, [])

  const deleteSticker = useCallback((id: string) => {
    setStickers((prev) => prev.filter((sticker) => sticker.id !== id));
    setSelectedStickerId((prevSelected) => (prevSelected === id ? null : prevSelected));
  }, [])

  const deselectSticker = useCallback(() => {
    setSelectedStickerId(null);
  }, [])

  return {
    addSticker,
    stickers,
    selectedStickerId,
    updateSticker,
    deleteSticker,
    selectSticker,
    deselectSticker
  };
}

export default useStickers;
